export const cursoMeta = (curso, fbid, url) => ({
  title: curso.name,
  link: [
    {
    rel:"preload",
    as:"image",
    href:curso.img ? "https://ik.imagekit.io/cyrcl27sn" + curso.img : '' 
  },
       {
    rel:"canonical",
    href: "https://multiversa.com/" + "/" + url + "/" + curso.slug + '/',
    },
  ],
  meta: [
    {
      hid: "https://multiversa.com/" + "/" + url + "/" + curso.slug + '/',
      name:curso.name,
      content:curso.description_seo,
      keywords: curso.meta_tags ? curso.meta_tags : "educacao, multiversa"
    },
    {
      name:"thumbnail",
      content:curso.img ? "https://ik.imagekit.io/cyrcl27sn" + curso.img : '' 
    },
    {name:"type", content:"article"},
    {property:"fb:app_id", hid:"fb:app_id", name:"fb:app_id", content: fbid },
    {property:"og:title", hid: "og:title", name:"og:title", content:curso.name },
    {property:"og:description", hid: "og:description", name:"og:description", content:curso.description_seo },
    {property:"og:site_name", hid: "og:site_name", name:"og:site_name", content:"Multiversa"},
    {property:"og:type", hid:"og:type", name:"og:type", content:"article"},
    { property:"og:image", hid: "og:image", itemprop:"image", name:"og:image", content:curso.img ? "https://ik.imagekit.io/cyrcl27sn" + curso.img : '' },
    { property:"og:image:secure_url", hid: "og:image:secure_url", itemprop:"image", name:"og:image:secure_url", content:curso.img ? "https://ik.imagekit.io/cyrcl27sn" + curso.img : '' },
    {property: "og:image:type", hid: "og:image:type", name: "og:image:type", content: curso.img ? curso.img.split('.')[1] : 'jpg' },
    { property: "og:url", hid: "og:url", name: "og:url", content: "https://multiversa.br/" + "/" + url + "/" + curso.slug + '/' },
    

    {property:"twitter:card", hid: "twitter:card", name:"twitter:card",  content:"summary_large_image" },
    {property:"twitter:title", hid: "twitter:title", name:"twitter:title", content:curso.name  },
    {property:"twitter:description", hid: "twitter:description", name:"twitter:description", content:curso.description_seo },
    
    {name:"robots", content:"index,follow"}
  ]
})
